// ******************** GET CSV DATA URL ********************
export const GET_CSV_DATA_LOADING = 'GET_CSV_DATA_LOADING';
export const GET_CSV_DATA_SUCCESS = 'GET_CSV_DATA_SUCCESS';
export const GET_CSV_DATA_ERROR = 'GET_CSV_DATA_ERROR';

// ******************** CLEAR CSV DATA ********************
export const CLEAR_CSV_DATA = 'CLEAR_CSV_DATA';
